import useApplianceManufacturers from '../data/appliance/useApplianceManufacturers';
import useApplianceModels from '../data/appliance/useApplianceModel';
import useApplianceTypes from '../data/appliance/useApplianceTypes';

const useApplianceTypeLookup = () => {
  const { applianceTypes } = useApplianceTypes();

  const lookup = (typeId: string) =>
    applianceTypes.data?.find((m) => m.id === typeId);

  return {
    isLoading: applianceTypes.isLoading,
    lookup,
  };
};

export interface ManufacturerLookupFilters {
  typeId?: string;
}

const useApplianceManufacturerLookup = ({
  typeId,
}: ManufacturerLookupFilters) => {
  const { applianceManufacturers } = useApplianceManufacturers(typeId);

  const lookup = (manufacturerId: string) =>
    applianceManufacturers.data?.find((m) => m.id === manufacturerId);

  return {
    isLoading: applianceManufacturers.isLoading,
    lookup,
  };
};

export interface ModelLookupFilters {
  manufacturerId?: string;
  typeId?: string;
}

const useApplianceModelLookup = ({
  manufacturerId,
  typeId,
}: ModelLookupFilters) => {
  const { applianceModels } = useApplianceModels(manufacturerId, typeId);

  const lookup = (modelId: string) =>
    applianceModels.data?.find((m) => m.id === modelId);

  return {
    isLoading: applianceModels.isLoading,
    lookup,
  };
};

export interface HardwareLookupFilters
  extends ManufacturerLookupFilters, ModelLookupFilters {}

export const useApplianceLookups = ({
  typeId,
  manufacturerId,
}: HardwareLookupFilters = {}) => {
  const { isLoading: typesLoading, lookup: typeLookup } =
    useApplianceTypeLookup();

  const { isLoading: manufacturersLoading, lookup: manufacturerLookup } =
    useApplianceManufacturerLookup({ typeId });

  const { isLoading: modelsLoading, lookup: modelLookup } =
    useApplianceModelLookup({ manufacturerId });

  const isLoading = manufacturersLoading || typesLoading || modelsLoading;

  return {
    isLoading,
    manufacturerLookup,
    typeLookup,
    modelLookup,
  };
};
